module.exports = __webpack_public_path__ + "static/mm-4ebc15c8fe8cd13719a1ea130a9d1b58.png";